import { Bar } from 'react-chartjs-2';
import { Box, Button, Card, CardContent, CardHeader, Divider, useTheme } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { faker } from '@faker-js/faker';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Sales = ({ props, typeNames, typeLength }) => {
  const theme = useTheme();
  //const labels = typeNames;
  const labels = ['Secretaria Municipal de Governo SEMUG', 'Secretaria Municipal de Esporte - SEMESPO'];
  typeLength = [2, 1];
  const typeLength2 = [0, 0];

  const data = {
    datasets: [
      {
        backgroundColor: '#3F51B5',
        barPercentage: 0.5,
        barThickness: 12,
        borderRadius: 4,
        categoryPercentage: 0.5,
        data: typeLength,
        label: 'Mais recente',
        maxBarThickness: 10
      },
      {
        backgroundColor: '#EEEEEE',
        barPercentage: 0.5,
        barThickness: 12,
        borderRadius: 4,
        categoryPercentage: 0.5,
        data: typeLength2,
        label: 'Ano passado',
        maxBarThickness: 10
      }
    ],
    labels: labels
  };

  const options = {
    animation: false,
    layout: { padding: 0 },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: theme.palette.background.paper,
        bodyColor: theme.palette.text.secondary,
        borderColor: theme.palette.divider,
        borderWidth: 1,
        enabled: true,
        footerColor: theme.palette.text.secondary,
        intersect: false,
        mode: 'index',
        titleColor: theme.palette.text.primary
      }
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        ticks: {
          color: theme.palette.text.secondary
        },
        grid: {
          display: false,
          drawBorder: false
        }
      },
      y: {
        ticks: {
          color: theme.palette.text.secondary,
          beginAtZero: true,
          min: 0
        },
        grid: {
          borderDash: [2],
          borderDashOffset: 2,
          color: theme.palette.divider,
          drawBorder: false
        }
      }
    }
  };

  return (
    <Card {...props} sx={{ backgroundColor: '#fff', marginRight: 1 }}>
      <CardHeader
        action={(
          <Button
            endIcon={<ArrowDropDownIcon fontSize="small" />}
            size="small"
          >
            Últimos anos
          </Button>
        )}
        sx={{ color: '#252525' }}
        title="Requerimentos cadastrados"
      />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 350,
            width: 600,
            position: 'relative'
          }}
        >
          <Bar
            data={data}
            options={options}
          />
        </Box>
      </CardContent>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2,
        }}
      >
        <Button
          color="primary"
          endIcon={<ArrowRightIcon fontSize="small" />}
          size="small"
        >
          Visão geral
        </Button>
      </Box>
    </Card>
  );
};


export default Sales;